import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, Button, Divider, Icon,
} from 'semantic-ui-react';
import _ from 'lodash';
import { withRouter } from 'react-router';
import ThemeSelector from '../../themes/theme-selector';

const HEADER_STYLE = { textAlign: 'center' };
const PRIMARY_PINK = { color: '#fc4085', ...HEADER_STYLE };
const PRIMARY_GREEN = { color: '#20c49e', ...HEADER_STYLE };
const PRIMARY_ORANGE = { color: '#fdb02b', ...HEADER_STYLE };
const DESC_STYLE = { textAlign: 'center', color: 'rgba(0,0,0,.4)' };
const CARD_GROUP_STYLE = { margin: 14 };
const NO_MARGIN = { margin: 0 };

const ACRSetup = ({
  campaignId,
  router,
  acrScanLoading,
  handleACRScan,
  addChannelDisabled,
  channelAdded,
  acrScanDisabled,
}) => {
  const platformName = ThemeSelector.theme().platformName || 'dyzio';
  const items = [
    {
      header: <h3 style={PRIMARY_PINK}>1. Add Channel</h3>,
      color: 'pink',
      meta: <Divider />,
      style: channelAdded ? { opacity: 0.6 } : {},
      description: <div style={DESC_STYLE}>
        <p>Select the influencer or Instagram channel from your My Influencers database.</p>
        <p> Only one channel can be automatically tracked.</p>
      </div>,
      extra: <div style={{ textAlign: 'center' }}>
        <Button
          color="pink"
          inverted
          icon={channelAdded ? 'check' : 'plus'}
          content={channelAdded ? 'Channel Added' : 'Add Channel'}
          disabled={addChannelDisabled}
          onClick={() => router.push(`/acr-campaign/${campaignId}/invite`)}
        />
      </div>,
    },
    {
      header: <h3 style={PRIMARY_GREEN}>2. Request Authorisation</h3>,
      color: 'green',
      meta: <Divider />,
      style: !channelAdded ? { opacity: 0.6 } : {},
      description: <div style={DESC_STYLE}>
        <p>To automatically track Instagram Post impressions and reach plus</p>
        <p>{`Instagram Stories data the channel needs to be authenticated to ${platformName}.`}</p>
      </div>,
      extra: <div style={DESC_STYLE}>
        <p>Use the pink hamburger button {'('}<Icon style={NO_MARGIN} name="bars" />{')'} on the</p>
        <p>influencer card to send an authorisation request.</p>
      </div>,
    },
    {
      header: <h3 style={PRIMARY_ORANGE}>3. View Dashboard</h3>,
      color: 'orange',
      meta: <Divider />,
      description: <div style={DESC_STYLE}>
        <p>All new Posts and Stories, from the selected channel, will be added to the dashboard daily.</p>
        <p>You can also scan the latest posts, click below.</p>
      </div>,
      style: !channelAdded ? { opacity: 0.6 } : {},
      extra: <div style={{ textAlign: 'center' }}>
        <Button
          loading={acrScanLoading}
          disabled={acrScanDisabled}
          onClick={handleACRScan}
          color="orange"
          inverted
          icon="search"
          content="Scan for latest posts"
        />
      </div>,
    },
  ];
  return (
    <div style={CARD_GROUP_STYLE}>
      <div style={CARD_GROUP_STYLE}>
        <h2>Automated Channel Report Set-up</h2>
        <span style={{ color: 'rgba(0,0,0,.4)' }}>
          {'To learn how Automated Channel Reports work '}
          <a
            href="https://help.dyzio.co/articles/3085024-automated-campaign-report"
            target="_blank"
            rel="noopener noreferrer"
          >
            click here
          </a>
        </span>
      </div>
      <Card.Group itemsPerRow={items.length} centered>
        { _.map(items, card => <Card {...card} />) }
      </Card.Group >
      <Divider hidden />
    </div>
  );
};

ACRSetup.propTypes = {
  campaignId: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(ACRSetup);



/** WEBPACK FOOTER **
 ** ./src/components/acr-setup/index.js
 **/